import { Tabs as AntdTabs } from 'antd';
import { Tab } from 'rc-tabs/lib/interface';
import { ErrorBadge } from './style';

export interface TabsProps {
  type?: 'line' | 'card' | 'editable-card';
  activeKey?: string;
  onChange?: (activeKey: string) => void;
  children?: React.ReactNode;
  defaultActiveKey?: string;
  tabBarExtraContent?:
    | React.ReactNode
    | { left?: React.ReactNode; right?: React.ReactNode };
  items?: Tab[];
  tabValidationErrors?: { [tabKey: string]: number };
  destroyInactiveTabPane?: boolean;
}

export const Tabs = ({
  type,
  activeKey,
  onChange,
  children,
  defaultActiveKey,
  tabBarExtraContent,
  items,
  tabValidationErrors = {},
  destroyInactiveTabPane = false,
}: TabsProps) => {
  const processedItems = items?.map((item) => {
    const errorCount = tabValidationErrors[item.key || ''];
    return {
      ...item,
      label: errorCount ? (
        <>
          {item.label}
          <ErrorBadge>{errorCount}</ErrorBadge>
        </>
      ) : (
        item.label
      ),
    };
  });

  return (
    <AntdTabs
      destroyInactiveTabPane={destroyInactiveTabPane}
      type={type}
      activeKey={activeKey}
      onChange={onChange}
      defaultActiveKey={defaultActiveKey}
      tabBarExtraContent={tabBarExtraContent}
      items={processedItems}
    >
      {children}
    </AntdTabs>
  );
};
